export { AutomationSimulationProvider } from './AutomationSimulationProvider'
export { useAutomationSimulationContext } from './simulation.atoms'
export {
  useAutomationSimulation,
  type AutomationSimulation,
  type UseAutomationSimulationProps,
  type WorkflowInput,
  type WorkflowInputByTriggerType
} from './useAutomationSimulation'
export { analyseAutomation } from './utils/analyseAutomation'
export {
  readApprovalOutcome,
  waitForApprovalOutcome,
  type ApprovalOutcome
} from './utils/approvalOutcome'
export {
  isSimulationSandboxLoaded,
  loadSimulationSandbox,
  setupExpressionEvaluator,
  type ExpressionEvaluation,
  type ExpressionEvaluator
} from './utils/evaluateExpression'
export { evaluatePaths } from './utils/evaluatePaths'
export { getTaskDependencies } from './utils/getTaskDependencies'
export { haveResolveInputsChanged } from './utils/haveResolveInputsChanged'
export { mergeSimulationInputDefaults } from './utils/mergeSimulationInputDefaults'
export { parseConductorWorkflow } from './utils/parseConductorWorkflow'
export { readDataFromTask } from './utils/readDataFromTask'
export {
  CACHED_DEPENDENCY_STALE_TIME,
  resolveDependencies,
  staleTimeFor
} from './utils/resolveDependencies'
export { resolveTaskData } from './utils/resolveTaskData'
export { selectStaleDependencies } from './utils/selectStaleDependencies'
export {
  SIMULATION_LOG_LABEL,
  logSimulationRun
} from './utils/simulationDeveloperLog'
export {
  MAX_PATHS,
  NON_QUOTE_SEMANTIC_TYPES,
  OPTIONAL_DEPENDENCY_EXECUTORS,
  QUOTE_APPROVAL_TERMINAL_MATCHERS,
  QUOTE_SEMANTIC_TYPES,
  SIMULATABLE_TASK_NAMES,
  SIMULATION_INPUT_DEFAULTS,
  TERMINAL_PRECEDENCE
} from './simulation.constants'
export type {
  AutomationAnalysis,
  DependencyFetcher,
  DependencyResolutionRunOutcome,
  IndeterminateReason,
  ResolutionContext,
  ResolvedTaskData,
  SimulationDependency,
  SimulationExpression,
  SimulationPath,
  SimulationResult,
  SimulationWorkflow,
  TerminalTaskMatcher,
  TerminalType
} from './simulation.types'
